"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchDisplaySpectatorsDto = void 0;
const get_display_spectators_dto_1 = require("./get-display-spectators.dto");
class WatchDisplaySpectatorsDto extends get_display_spectators_dto_1.GetDisplaySpectatorsDto {
    intervalInMilliseconds;
}
exports.WatchDisplaySpectatorsDto = WatchDisplaySpectatorsDto;
